module.exports = __webpack_public_path__ + "img/class1.06b2eccc.webp";